<template>
  <div class="content-edit">

    <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
      <div class="white-container">
        <el-form-item label="训练计划标题" prop="title" style="width: 464px">
          <el-input v-model="form.title" :disabled="comReadonly" maxlength="10" placeholder="请输入活动标题，最多不超过10个字" />
        </el-form-item>
        <el-form-item label="计划亮点" prop="introduction" style="width: 764px">
          <el-input v-model="form.introduction" :disabled="comReadonly" type="textarea" :autosize="{ minRows: 4,}" placeholder="请输入活动介绍" />
        </el-form-item>
        <el-form-item label="注意事项" prop="note" style="width: 764px">
          <el-input v-model="form.note" :disabled="descReadonly" type="textarea" :autosize="{ minRows: 4,}" placeholder="请输入活动介绍" />
        </el-form-item>
      </div>
      <div class="white-container marginTop task-label">
        <el-form-item label="添加任务" prop="meridianCampPlanTaskAddDTOS" style="width: 100%; margin-left: -30px;">
          <br>
          <div v-if="form.meridianCampPlanTaskAddDTOS.length" class="task-box">
            <template v-for="(item,index) in form.meridianCampPlanTaskAddDTOS">
              <PlanTask :key="index" :task="item" :disabled="comReadonly" @deleteCourse="deleteCourse" @deleteTask="deleteTask" @addCourse="openCourseDialog" />
            </template>
          </div>
          <br>
          <div class="add-task-btn-box">
            <el-button icon="el-icon-plus" :disabled="comReadonly" plain @click="addTask">添加任务</el-button>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop task-label">
        <el-form-item label="上传图片" prop="bannerList" style="width: 100%; margin-left: -30px;">
          <br>
          <div class="uploadImg-wrapper">
            <UploadImage required :img-info="{ name: '训练计划详情页头图', size: 5, width: 1125, height: 1125,key: 'activityDetailsPageHeader' }" :image-url="form.bannerList.activityDetailsPageHeader || ''" :disabled="comReadonly" @upload="handleImageUpload" />
            <UploadImage :img-info="{ name: 'CAMP首页训练计划BANNER', size: 5, width: 540, height: 336,key: 'planBannerPicture' }" :image-url="form.bannerList.planBannerPicture || ''" :disabled="comReadonly" @upload="handleImageUpload" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop submit-btn-box">
        <el-form-item style="width: 100%; margin-left: -50px;">
          <div class="flex btns">
            <el-button class="btn" type="info" @click="handleCancel">取消</el-button>
            <el-button class="btn" type="primary" :disabled="comReadonly && descReadonly" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
    <el-dialog v-if="courseDialogVisible" :visible.sync="courseDialogVisible" title="添加任务" custom-class="course-wrapper">
      <div class="">
        <p class="course-title">选择课程</p>
        <div class="search-form">
          <div class="search-input-box">
            <el-input v-model="search.name" class="search-input" placeholder="请输入课程ID" prefix-icon="el-icon-search" />
          </div>
          <el-button class="search-btn" type="primary" @click="searchCourse">搜索</el-button>
          <el-button class="reset-btn" plain @click="resetCourse">重置</el-button>
        </div>
        <el-table ref="multipleTable" size="small" :data="courselist" height="360" style="width: 100%">
          <el-table-column prop="id" label="课程ID" width="60" />
          <el-table-column prop="coverImage" label="课程图片" width="auto">
            <template v-slot="{row}">
              <img :src="row.coverImage" alt="" style="width: 80px; height: 80px; object-fit: cover;">
            </template>
          </el-table-column>
          <el-table-column prop="name" label="课程名称" width="auto" />
          <el-table-column fixed="right" label="操作">
            <template v-slot="{row}">
              <span v-if="row.status">已选择</span>
              <el-button v-else size="small" type="text" class="link-color" @click="selectCourse(row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="submit-btn-box">
          <el-button class="btn" type="primary" @click="submitCourse">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
import UploadImage from '../components/uploadImage.vue';
import PlanTask from '../components/planTask.vue';
export default {
  components: { Dialog, UploadImage, PlanTask },

  data() {
    return {
      search: {
        name: '',
      },
      comReadonly: false,
      descReadonly: false,
      courselist: [],
      form: {
        title: '',
        introduction: '',
        note: '',
        bannerList: {
          activityDetailsPageHeader: '',
          planBannerPicture: '',
        },
        meridianCampPlanTaskAddDTOS: [],
      },
      formDialogShow: false,
      courseDialogVisible: false,
      information: {},
      rules: {
        title: [
          { required: true, message: "请输入训练计划标题", trigger: ["blur"] },
        ],
        introduction: [
          { required: true, message: "请输入计亮点", trigger: ["blur"] },
        ],
        meridianCampPlanTaskAddDTOS: [
          { required: true, message: "请添加关联任务", trigger: ["blur"] },
        ],
      },
    };
  },
  async created() {
  },
  mounted() {
    const { query } = this.$route;
    const { id, type } = query;
    if (id && type) {
      this.handleType = type;
      this.oldId = id;
      this.getPlanDetail();
    } else {
      this.handleType = 'add';
    }
    if (this.handleType === 'preview') {
      this.comReadonly = true;
      this.descReadonly = true;
    }
    if (this.handleType === 'edit' && +query.status > 2) {
      this.comReadonly = true;
      this.descReadonly = false;
    }
    console.log('this.comReadonly', this.comReadonly);
    console.log('this.descReadonly', this.descReadonly);
  },
  beforeDestroy() { },
  methods: {
    submit() {
      this.$refs.form.validate().then(res => {
        if (res) {
          if (this.form.meridianCampPlanTaskAddDTOS.length === 0) {
            this.$message.error('请先添加任务');
            return;
          }
          for (let i = 0; i < this.form.meridianCampPlanTaskAddDTOS.length; i++) {
            const task = this.form.meridianCampPlanTaskAddDTOS[i];
            console.log('task', task);
            if (task.content.length === 0 || task.campTopic.trim() === '') {
              this.$message.error('请完善任务内容1');
              return;
            }
            for (let j = 0; j < task.content.length; j++) {
              const content = task.content[j];
              if (!content.taskImage) {
                this.$message.error('请完善任务内容2');
                return;
              }
            }
          }
          if (!this.form.bannerList.activityDetailsPageHeader) {
            this.$message.error('请完善训练计划详情页头图');
            return;
          }
          this.formDialogShow = true;
          this.information = {
            operation: "submit",
            icon: "warn",
            subTitle: "是否确认保存编辑的内容？",
          };
        }
      });
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        if (this.handleType === 'edit') {
          this.editActivity();
        } else {
          this.addActivity();
        }
      }
    },
    addTask() {
      const taskObj = {
        campTopic: '',
        content: [],
        taskDay: this.form.meridianCampPlanTaskAddDTOS.length + 1,
        taskDayIndex: this.form.meridianCampPlanTaskAddDTOS.length,
      };
      this.form.meridianCampPlanTaskAddDTOS.push(taskObj);
      this.form.meridianCampPlanTaskAddDTOS.forEach((item, index) => {
        item.taskDay = index + 1;
        item.taskDayIndex = index;
      });
      this.form.meridianCampPlanTaskAddDTOS = [...this.form.meridianCampPlanTaskAddDTOS];
    },
    deleteTask(taskDayIndex) {
      const taskIndex = this.form.meridianCampPlanTaskAddDTOS.findIndex(
        item => item.taskDayIndex === taskDayIndex
      );
      if (taskIndex !== -1) {
        this.form.meridianCampPlanTaskAddDTOS.splice(taskIndex, 1);
        this.form.meridianCampPlanTaskAddDTOS.forEach((item, index) => {
          item.taskDayIndex = index;
          item.taskDay = index + 1;
        });
      }
    },
    handleImageUpload(data) {
      this.form.bannerList[data.key] = data.url;
      console.log('this.form.bannerList', this.form.bannerList);
    },
    searchCourse() {
      if (!this.search.name.trim()) {
        this.$message.warning('请输入课程ID或名称');
        return;
      }
      this.$Api.newCamp.courseSelect(this.search.name).then(data => {
        const selectList = this.form.meridianCampPlanTaskAddDTOS.find(item => item.taskDayIndex === this.currentTaskDay);
        const filterList = data.filter(item => !selectList.content.some(content => content.taskId === item.id));
        this.courselist = filterList.map(item => ({
          ...item,
          status: 0, // 1 已选择 0 未选择
        }));
      });
    },
    selectCourse(row) {
      this.courselist.forEach(item => {
        if (item.id === row.id) {
          item.status = 1;
        }
      });
    },
    submitCourse() {
      this.courseDialogVisible = false;
      const selectList = this.courselist.filter(item => item.status === 1);
      if (selectList.length === 0) {
        this.$message.error('未选择课程');
        return;
      }
      const addList = selectList.map(item => {
        const taskContentObj = {
          taskDay: this.currentTaskDay + 1,
          taskId: item.id,
          taskImage: '',
          taskName: item.name,
        };
        return taskContentObj;
      });
      this.form.meridianCampPlanTaskAddDTOS[this.currentTaskDay].content.push(...addList);
    },
    deleteCourse(element) {
      this.form.meridianCampPlanTaskAddDTOS[element.taskDay - 1].content = this.form.meridianCampPlanTaskAddDTOS[element.taskDay - 1].content.filter(item => item.taskId !== element.taskId);
    },
    resetCourse() {
      this.search = { name: '' };
      this.courselist = [];
    },
    handleCancel() {
      if (this.handleType === 'preview') {
        this.$router.go(-1);
      } else {
        this.formDialogShow = true;
        this.information = {
          operation: 'cancel',
          icon: 'warn',
          subTitle: `是否放弃编辑，返回上级页面？`,
        };
      }
    },
    openCourseDialog(taskDayIndex) {
      this.currentTaskDay = taskDayIndex;
      this.resetCourse();
      this.courseDialogVisible = true;
    },
    addActivity() {
      this.handleType === 'copy' && (delete this.form.id);
      this.form.days = this.form.meridianCampPlanTaskAddDTOS.length;
      const params = {
        ...this.form,
      };
      this.$Api.newCamp.planAdd(params).then(data => {
        this.$message.success('新增成功');
        this.$router.go(-1);
      });
    },
    editActivity() {
      this.form.days = this.form.meridianCampPlanTaskAddDTOS.length;
      this.$Api.newCamp.planEdit(this.form).then(data => {
        this.$message.success('编辑成功');
        this.$router.go(-1);
      });
    },
    async getPlanDetail() {
      this.$Api.newCamp.planDetail(this.oldId).then(data => {
        data.meridianCampPlanTaskAddDTOS.forEach((item, index) => {
          // item.taskDay = index + 1;
          item.taskDayIndex = index;
        });
        this.form = data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mb30{
  margin-bottom: 30px;
}
.white-container{
  padding-bottom: 1px;
}
.content-edit {
  .btns {
    align-items: center;
    justify-content: center;
    .btn{
      width: 120px;
      height: 40px;
    }
  }
  .marginTop {
    margin-top: 30px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
}
/deep/ .task-label{
  .el-form-item__label{
    font-size: 16px;
    font-weight: 500;
  }
  .el-button.is-plain:focus, .el-button.is-plain{
    width: 150px;
    height: 34px;
    border-style: dashed;
    span{
      color: #9B9B9B;
    }

  }
}
.add-task-btn-box{
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.uploadImg-wrapper{
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
  margin-left: -76px;
}
.task-box{
  margin-left: -80px;
}
.submit-btn-box{
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .btn{
    width: 170px;
    height: 50px;
  }
}
/deep/.course-wrapper {
    width: 678px;
    height: 660px;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      height: 400px;
      padding: 30px;
      box-sizing: border-box;
      .qr-wrap {
        text-align: center;
        .qr-code {
          width: 300px;
          height: 300px;
          margin-bottom: 20px;
        }
        p {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 23px;
          color: #494949;
        }
      }
    }
    .course-title{
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
    }
    .search-form{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      margin:20px 0
    }
    .search-input-box{
      width: 140px;
      height: 34px;
      .el-input__inner{
        height: 34px;
      }
    }
    .search-btn,.reset-btn{
      width: 62px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 0;
    }
  }
</style>

